import { createSellCryptoOrder } from 'components/features/rewards/rewardsPane/store/epics/sellMode/createSellCryptoOrder'
import { createSellCryptoPreviewOrderEpic } from 'components/features/rewards/rewardsPane/store/epics/sellMode/createSellCryptoPreviewOrder'
import { combineEpics } from 'redux-observable'
import { openSellCryptoEpic } from 'components/features/rewards/rewardsPane/store/epics/sellMode/openSellCryptoEpic'

export const rewardsPaneSellModeEpic = combineEpics(
  createSellCryptoPreviewOrderEpic,
  createSellCryptoOrder,
  openSellCryptoEpic,
)
